import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UserPreferencesService } from '@alfresco/adf-core';

@Injectable({
  providedIn: 'root',
})
export class WkUserPreferencesService {
  get paginationSize(): number {
    return this.userPreferenceService.paginationSize;
  }
  constructor(private readonly userPreferenceService: UserPreferencesService) {}

  select(property: string): Observable<any> {
    return this.userPreferenceService.select(property);
  }

  get(property: string, defaultValue: string = null): string {
    return this.userPreferenceService.get(property, defaultValue);
  }

  set(property: string, value: any) {
    this.userPreferenceService.set(property, value);
  }
}
